(function (angular) {
    angular.module('bizPartEngage').controller('modules.certifications', indexController);

    indexController.$inject = ["$stateParams", "$state", "modules.certifications.service", "$rootScope", "bizJourneyService"];

    function indexController($stateParams, $state, certService, $rootScope, bizJourneyService) {
        var vm = this;

        vm.CertList = [];
        vm.NoImageUrl = 'Images/Common/no_img.svg';

        vm.Init = Init;
        vm.GetCertifications = GetCertifications;
        vm.GoToEo = GoToEo;
		vm.ToggleCertificationItems = ToggleCertificationItems;

        function GoToEo(ItemType, item) {
			if(ItemType === 2) {
				bizJourneyService.GoToEngageItem(item);
				return;
			}

            let journey = $rootScope.Journeys.GetItemByValue('Id', item.Id);

            if (journey && journey.EngageObjects.length > 0) {
                for (var i = 0; i < journey.EngageObjects.length; i++) {
                    if (journey.EngageObjects[i].Status != 3) {
                        bizJourneyService.GoToEngageItem(journey.EngageObjects[i]);
                        return;
                    }
                }

                bizJourneyService.GoToEngageItem(journey.EngageObjects[0]);
            }
        }

        function GetCertifications() {
            certService.GetCertificationsForUser().then(GetCertificationsForUserSuccess);

			function GetCertificationsForUserSuccess(response) {
				$rootScope.JourneysInitialized.then(() => {
					vm.CertList = BizPartCoreHelpers.getResponseValue(response, []);
					for (var i = 0; i < vm.CertList.length; i++) {                                        
						vm.CertList[i].UserData = vm.CertList[i].UserData || {};
						vm.CertList[i].Items = vm.CertList[i].Items || [];

						var totalXp = 0;
						var journeyCount = 0;
						var totalCompletedObjects = 0;
						var totalObjects = 0;
						var completedItems = 0;

						for (var j = 0; j < vm.CertList[i].Items.length; j++) {                        
							if (!vm.CertList[i].Items[j].Item) {
								continue;
							}

							totalXp = totalXp + (vm.CertList[i].Items[j].Item.ExperienceGive || 0);                        

						
								if (vm.CertList[i].Items[j].ItemType == 3) {
									var journey = $rootScope.Journeys.GetItemByValue('Id', vm.CertList[i].Items[j].Item.Id);
									if (journey !== null) {
										var completedInJourney = 0;
										for (var k = 0; k < journey.EngageObjects.length; k++) {
											if (journey.EngageObjects[k].Status == 3) {
												completedInJourney++;
											}
										}

										var journeyProgress = journey.EngageObjects.length > 0
											? Math.round((completedInJourney / journey.EngageObjects.length) * 100)
											: 0;

										vm.CertList[i].Items[j].Item.ProgressPercent = journeyProgress;
										vm.CertList[i].Items[j].Item.UserHasPassed = completedInJourney === journey.EngageObjects.length && journey.EngageObjects.length > 0;
										vm.CertList[i].Items[j].Item.TotalTimeMinutes = journey.TotalTimeMinutes;
										vm.CertList[i].Items[j].Item.ModuleCount = journey.EngageObjects.length;

										totalCompletedObjects += completedInJourney;
										totalObjects += journey.EngageObjects.length;
										journeyCount++;
									}
								}

							if (IsItemCompleted(vm.CertList[i].Items[j])) {
								completedItems++;
							}
						
						}
						vm.CertList[i].ExperienceGive = totalXp;

						if (journeyCount > 0) {
							vm.CertList[i].UserData.ProgressPercent = totalObjects > 0 
								? Math.round((totalCompletedObjects / totalObjects) * 100) 
								: 0;
							vm.CertList[i].IsJourney = true;
						}

						vm.CertList[i].Ui = {
							IsExpanded: false,
							CompletedItems: completedItems,
							TotalItems: vm.CertList[i].Items.length
						};
					}
				});
            }
        }

		function ToggleCertificationItems(certification) {
			if (!certification || !certification.Ui) {
				return;
			}

			certification.Ui.IsExpanded = !certification.Ui.IsExpanded;
		}

		function IsItemCompleted(item) {
			if (!item || !item.Item) {
				return false;
			}

			return item.Item.UserHasPassed === true || (item.Item.ProgressPercent || 0) >= 100;
		}

        function Init() {            
            vm.GetCertifications();
        }

        this.$onInit = vm.Init;
    }

})(window.angular);
